/* eslint-disable no-restricted-syntax */
import React from 'react';
import PropTypes from 'prop-types';
// import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import Typography from '@digital-hig/mui/dist/Typography';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
// eslint-disable-next-line import/no-extraneous-dependencies
import MUILink from '@mui/material/Link';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Carousel from './carousel';
import CommonCard from './commonCard';
import { getLearningRecords } from '../store/userSlice';
import { triggerManualLinkClick } from '../common/analyticsApi';

const RelatedLearning = ({
  data, sectionRef, sectionId, optionsOverride,
}) => {
  const { relatedLearning, relatedTags } = data || {};
  const learningRecords = useSelector(getLearningRecords);

  const buildTags = (tags) => {
    const rows = [];
    for (const [key, value] of Object.entries(tags)) {
      const tagLinks = value.map((obj, i) => (
        <>
          <MUILink component={Link} to={`/catalog/${obj.url}`} onClick={() => triggerManualLinkClick({ linkTitle: `relatedTags:${key}:${obj.displayName}` })}>
            {obj.displayName}
          </MUILink>
          {`${i !== value.length - 1 ? ',' : ''} `}
        </>
      ));

      rows.push(
        <Grid component="li" key={key}>
          <Typography className="taxonomy" variant="headline-smallest">
            {key}
            :
          </Typography>
          <Typography variant="body-copy-small" className="tags">
            {tagLinks}
          </Typography>
        </Grid>,
      );
    }
    return rows;
  };

  const options = {
    mobileCount: 1,
    tabletCount: 2,
    desktopCount: 3,
    scrollBy: 'tray',
    ...optionsOverride,
  };

  return (
    <RootElement ref={sectionRef} data-id={sectionId} id="relatedLearning">
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}

      {!relatedLearning?.length > 0 && relatedTags && ( // If no carousel then display H2 here
        <Typography component="h2" variant="headline-medium" className="title">Related learning</Typography>
      )}
      {relatedLearning?.length !== 0 && ( // If carousel then set the H2 as the title of the carousel
        <Carousel
          title={<Typography component="h2" variant="headline-medium" className="title">Related learning</Typography>}
          options={options}
          scrollEventCallback={(direction) => {
            triggerManualLinkClick({ linkTitle: `relatedLearning:scroll ${direction}` });
          }}
        >
          {relatedLearning?.map((learning) => <CommonCard key={learning.id} analyticsArea="relatedLearning" data={learning} learningRecords={learningRecords} />)}
        </Carousel>
      )}
      {relatedTags && (
        <Grid container className="related-tags">
          <Grid lg={8}>
            <Typography component="h3" variant="headline-small">
              Browse content with related tags
            </Typography>
            <Grid item component="ul">
              {buildTags(relatedTags)}
            </Grid>
          </Grid>
        </Grid>
      )}
    </RootElement>
  );
};
const RootElement = styled.div`
  .related-tags {
    margin-top: 44px;
    ul {
      padding: 0;
      margin-top: 20px;
      li{
        list-style: none;
        padding: 0;
        margin: 0 0 16px 0;
        span.taxonomy {
          font-weight: bold;
        }
      }
    }
  }
`;

RelatedLearning.propTypes = {
  data: PropTypes.shape({ relatedLearning: PropTypes.arrayOf(), relatedTags: PropTypes.shape({}) }),
  sectionRef: PropTypes.shape({}).isRequired,
  sectionId: PropTypes.string.isRequired,
  optionsOverride: PropTypes.shape({}),
};
RelatedLearning.defaultProps = {
  data: {
    relatedLearning: [],
    relatedTags: {},
  },
  optionsOverride: {},
};

export default React.memo(RelatedLearning);
